import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import logo from '../../../../assets/img/benjy-logo.jpg'


export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,

    defaultData,

    //------------- Forms
    Forms,

    globalStates,
    helpers

}) => {

    const navigate = useNavigate();


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {

        const { fetchAllAdvance: { executeFetchAllAdvance, setParamsToSearch } } = FetchData
        const { idexpense } = dataRequest

        if (compont === 'advance-section') {
            setParamsToSearch({ idexpense: idexpense })
            executeFetchAllAdvance()
        }

        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormExpenses, FormAdvance, FormStatus } = Forms
        const { onResetForm } = FormExpenses
        onResetForm()
        FormAdvance.onResetForm()
        FormStatus.onResetForm()
        closeModal()
    }

    const handleClickEditExpense = async (idexpense) => {
        const { FormExpenses: { setFormState } } = Forms
        const { fetchInfoExpenses: { executeFetchInfoExpense } } = FetchData

        await setFormState(prevState => ({
            ...prevState,
            idexpense: idexpense,
        }))

        executeFetchInfoExpense()
        handleClickShowModal('', 'Formulario de gastos', 'expenses-section', {}, 'EDITABLE')

    }


    const onSubmitFormVehicle = async (e) => {
        e.preventDefault();
        const { getCurrentDate } = helpers
        const { setShowForm } = globalStates

        const { FormVehicle: { formState } } = Forms
        const { fetchAllVehicles: { executeFetchAllVehicles }, fetchVehicleImages: { executeFetchVehicleImages } } = FetchData


        if ((formState.origen === "") || (formState.disponibilidad === "")) {
            const messageCustom = {
                message: 'Debe seleccionar un origen y disponiblidad',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = {
            tipo: formState.tipo,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            motorCC: formState.motorCC,
            motorNo: formState.motorNo,
            chasis: formState.chasis,
            origen: formState.origen,
            disponibilidad: formState.disponibilidad,
            costo: formState.clean_costo,
        }

        if (formState.idvehicle > 0) {
            _data['usuario_modifico'] = user.username;
            _data['fecha_modifico'] = getCurrentDate();
            await marvarApi.put(`/vehicle/common/update-vehicle/${formState.idvehicle}`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllVehicles()
                        handleClickCloseForm()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        } else {
            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();
            await marvarApi.post(`/vehicle/common/create-vehicle`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllVehicles()
                        handleClickCloseForm()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    }

    const onSubmitVehicleImages = async (e) => {

        e.preventDefault()

        const { FormVehicle: { formState, setFormState } } = Forms
        const { getCurrentDate } = helpers


        const { fetchVehicleImages: { executeFetchVehicleImages } } = FetchData



        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado niguna imagen',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idvehicle', formState.idvehicle);
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        if (formState.idvehicle > 0) {

            await marvarApi.post(`/vehicle/common/create-vehicle-images`, _data)
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                        // executeFetchAllFiles()
                        executeFetchVehicleImages()

                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const onSubmitFormExpenses = async (e) => {
        e.preventDefault();
        const { getCurrentDate } = helpers

        const { FormExpenses: { formState }, FormVehicle } = Forms
        const { fetchVehicleExpenses: { executeFetchAllVehicleExpenses } } = FetchData

        const formStateVehicle = FormVehicle.formState

        const _data = {
            title: formState.title,
            description: formState.description,
            supplier: formState.supplier,
            advance: formState.clean_advance,
            expense: formState.clean_expense,
        }

        if (formState.idexpense > 0) {
            _data['usuario_modifico'] = user.username;
            _data['fecha_modifico'] = getCurrentDate();
            await marvarApi.put(`/vehicle/vehicle/update-expense/${formState.idexpense}`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllVehicleExpenses()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        } else {
            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();
            await marvarApi.post(`/vehicle/vehicle/create-vehicle-expense/${formStateVehicle.idvehicle}`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllVehicleExpenses()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    }

    const onSubmitFormAdvance = async (e, idexpense) => {
        e.preventDefault();
        const { getCurrentDate } = helpers

        const { FormAdvance: { formState, onResetForm } } = Forms
        const { fetchAllAdvance: { executeFetchAllAdvance, setParamsToSearch }, fetchVehicleExpenses: { executeFetchAllVehicleExpenses } } = FetchData


        const _data = {
            description: formState.description,
            advance: formState.clean_advance,
            usuario_creo: user.username,
            fecha_creo: getCurrentDate(),
        }

        await marvarApi.post(`/vehicle/vehicle/create-vehicle-advance/${idexpense}`, _data)
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    setParamsToSearch({ idexpense: idexpense })
                    executeFetchAllAdvance()
                    executeFetchAllVehicleExpenses()
                    onResetForm()
                }

            }).catch(error => { console.log('API ERROR: ', error) })


    }

    const onSubmitFormStatus = async (e) => {
        e.preventDefault();
        const { getCurrentDate } = helpers

        const { FormStatus: { formState }, FormVehicle } = Forms
        const { fetchAllStatus: { executeFetchAllVehicleStatus } } = FetchData

        const formStateVehicle = FormVehicle.formState

        const _data = {
            idvehicle: formStateVehicle.idvehicle,
            fecha: formState.fecha,
            disponibilidad: formState.disponibilidad,
            ubicacion: formState.ubicacion,
            description: formState.description,
            usuario_creo: user.username,
            fecha_creo: getCurrentDate(),
        }


        await marvarApi.post(`/vehicle/vehicle/create-vehicle-status/${formState.idestado}`, _data)
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    executeFetchAllVehicleStatus()
                    handleClickCloseModal()
                }

            }).catch(error => { console.log('API ERROR: ', error) })

    }

    const handleClickCleanUpFiles = (event) => {
        const { FormVehicle: { setFormState } } = Forms

        // const { fetchAllDeposits } = FetchData
        // const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        // executeFetchAllDeposits()

    }

    const handleClickDeleteVehicleImage = (idimage) => {

        const { fetchVehicleImages: { executeFetchVehicleImages } } = FetchData

        Swal.fire({
            title: '¿Desea eliminar esta imagen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/common/delete-vehicle-image/${idimage}`)
                    .then(async ({ data }) => {
                        alertMessage(data)

                        if (data.title === 'OK') {
                            await executeFetchVehicleImages()
                        }

                    }).catch(e => {
                        console.log(e)
                        Swal.fire({
                            icon: 'error',
                            title: 'Ocurrio un problema',
                            text: 'Comuniquese con mantenimiento'
                        })
                    })
            }
        })
    }

    const handleClickShowForm = async () => {
        const { setShowSection } = globalStates
        setShowSection('FORM')
    }

    const handleClickCloseForm = () => {
        const { setShowSection, setImagesCurrentIndex } = globalStates
        const { FormVehicle: { onResetForm } } = Forms

        onResetForm()
        setShowSection('HOME')
        setImagesCurrentIndex(0)
    }

    const handleClickShowInfoVehicle = async (idvehicle) => {
        const { FormVehicle: { setFormState } } = Forms
        const { fetchInfoVehicle: { executeFetchInfoVehicle }, fetchVehicleImages: { executeFetchVehicleImages } } = FetchData

        await setFormState((prevState) => ({
            ...prevState,
            idvehicle: idvehicle,
        }))

        await executeFetchVehicleImages()
        await executeFetchInfoVehicle()
        await handleClickShowForm()
    }

    const handleClickShowVehicleImages = async (idvehicle) => {
        const { FormVehicle: { setFormState } } = Forms
        const { setShowSection } = globalStates
        const { fetchVehicleImages: { executeFetchVehicleImages } } = FetchData

        await setFormState((prevState) => ({
            ...prevState,
            idvehicle: idvehicle,
        }))

        await executeFetchVehicleImages()

        setShowSection('IMAGES')
    }

    const handleClickShowVehicleExpense = async (idvehicle) => {
        const { FormVehicle: { setFormState } } = Forms
        const { setShowSection } = globalStates
        const { fetchVehicleExpenses: { executeFetchAllVehicleExpenses } } = FetchData

        await setFormState((prevState) => ({
            ...prevState,
            idvehicle: idvehicle,
        }))

        await executeFetchAllVehicleExpenses()

        setShowSection('EXPENSES')
    }

    const handleNextImage = () => {
        const { FormVehicle: { formState } } = Forms
        const images = formState.images

        const { setImagesCurrentIndex, imagesCurrentIndex } = globalStates

        setImagesCurrentIndex((prevIndex) =>
            prevIndex + 1 < images.length ? prevIndex + 1 : 0
        );

    }

    const handlePreviousImage = () => {
        const { FormVehicle: { formState } } = Forms
        const images = formState.images

        const { setImagesCurrentIndex, imagesCurrentIndex } = globalStates

        setImagesCurrentIndex((prevIndex) =>
            prevIndex - 1 >= 0 ? prevIndex - 1 : images.length - 1
        );

    }

    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const handleClickDeleteVehicleExpense = (idexpense) => {

        const { fetchVehicleExpenses: { executeFetchAllVehicleExpenses } } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este gasto?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/vehicle/delete-expense/${idexpense}`)
                    .then(async ({ data }) => {
                        alertMessage(data)

                        if (data.title === 'OK') {
                            await executeFetchAllVehicleExpenses()
                        }

                    }).catch(e => {
                        console.log(e)
                        Swal.fire({
                            icon: 'error',
                            title: 'Ocurrio un problema',
                            text: 'Comuniquese con mantenimiento'
                        })
                    })
            }
        })
    }

    const handleClickShowVehicleStatus = async (idvehicle) => {
        const { FormVehicle: { setFormState } } = Forms
        const { setShowSection } = globalStates
        const { fetchAllStatus: { executeFetchAllVehicleStatus } } = FetchData

        await setFormState((prevState) => ({
            ...prevState,
            idvehicle: idvehicle,
        }))

        await executeFetchAllVehicleStatus()

        setShowSection('STATUS')
    }

    const handleClickDeleteVehicleStatus = (idestado) => {

        const { fetchAllStatus: { executeFetchAllVehicleStatus } } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este estado?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/vehicle/delete-status/${idestado}`)
                    .then(async ({ data }) => {
                        alertMessage(data)

                        if (data.title === 'OK') {
                            await executeFetchAllVehicleStatus()
                        }

                    }).catch(e => {
                        console.log(e)
                        Swal.fire({
                            icon: 'error',
                            title: 'Ocurrio un problema',
                            text: 'Comuniquese con mantenimiento'
                        })
                    })
            }
        })
    }

    const handleClickEditStatus = async (idestado) => {
        const { FormStatus: { setFormState } } = Forms
        const { fetchInfoStatus: { executeFetchInfoStatus } } = FetchData

        await setFormState(prevState => ({
            ...prevState,
            idestado: idestado,
        }))

        executeFetchInfoStatus()
        handleClickShowModal('', 'Ubicacion y Estado del Vehiculo', 'status-section', {}, 'EDITABLE')
    }

    const handleChangeAmount = (event) => {

        const { numberFormatter, convertToFloat } = helpers

        //HOOKS
        const { FormVehicle } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormVehicle
        const { clean_costo_total } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        setFormState(prevState => ({
            ...prevState,
            costo_total: numberFormatter.format(clean_costo_total + clean_value),
        }))

    }

    const handleChangeCheckBox = (event, idexpense) => {
        const { checked } = event.target
        const { fetchVehicleExpenses: { setVehicleExpenses } } = FetchData

        setVehicleExpenses(prevState =>
            prevState.map(item =>
                item.idexpense === idexpense
                    ? { ...item, check_print: checked }  // Si coincide el ID, actualiza check_print
                    : item  // Si no coincide, mantén el item sin cambios
            )
        )
    }

    const generatePDF = async () => {

        const { fetchVehicleExpenses: { vehicleExpenses } } = FetchData

        console.log(vehicleExpenses.some(item => item.check_print === true))

        if (!vehicleExpenses.some(item => item.check_print === true)) {
            alertMessage({
                flag: 'FAIL',
                message: 'Debe seleccionar al menos una compra para imprimir',
                rows: []
            })
            return
        }

        const vehiculo = vehicleExpenses[0]?.vehicle || 'Vehiculo desconocido';
        const fecha = vehicleExpenses[0]?.date || ' ';

        const doc = new jsPDF();

        let y = 15

        const imgWidth = 50;
        const imgHeight = 20;
        doc.addImage(logo, 'PNG', 150, 26, imgWidth, imgHeight);

        // Membrete
        doc.setFont("helvetica", "bold");
        doc.setFontSize(25);
        doc.text('Lista de Compras Vehiculos', 105, y, null, null, "center");
        y += 20;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(`Vehiculo: ${vehiculo}`, 15, y);
        y += 5;
        doc.text(`Fecha: ${fecha}`, 15, y);
        y += 10;

        let columns;
        let rows;

        columns = ['No', 'Descripcion', 'Proveedor', 'Anticipo Inicial', 'Anticipo total', 'Total'];
        rows = vehicleExpenses
            .filter(vehicle => vehicle.check_print === true) // Solo elementos checkeados
            .map((vehicle, index) => [
                index + 1,
                vehicle.title,
                vehicle.supplier,
                vehicle.advance,
                vehicle.total_advances,
                vehicle.expense,
            ]);

        // Agregar la tabla al PDF
        doc.autoTable({
            head: [columns],
            body: rows,
            startY: y,
        });

        // Guardar el PDF
        doc.save('lista_compra_vehiculos.pdf');
    };

    const handleClickDeleteVehicleAdvance = (idadvance) => {

        const { fetchAllAdvance: { executeFetchAllAdvance } } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este anticipo?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/vehicle/delete-advance/${idadvance}`)
                    .then(async ({ data }) => {
                        alertMessage(data)

                        if (data.title === 'OK') {
                            await executeFetchAllAdvance()
                        }

                    }).catch(e => {
                        console.log(e)
                        Swal.fire({
                            icon: 'error',
                            title: 'Ocurrio un problema',
                            text: 'Comuniquese con mantenimiento'
                        })
                    })
            }
        })
    }

    return Object.freeze({
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormVehicle,
        onSubmitVehicleImages,
        onSubmitFormExpenses,
        onSubmitFormAdvance,
        onSubmitFormStatus,
        handleClickShowForm,
        handleClickCloseForm,
        handleClickShowInfoVehicle,
        handleClickShowVehicleImages,
        handleClickShowVehicleExpense,
        handleNextImage,
        handlePreviousImage,
        handleClickDeleteVehicleImage,
        handleClickDownloadImage,
        handleClickCleanUpFiles,
        handleClickDeleteVehicleExpense,
        handleClickEditExpense,
        handleClickShowVehicleStatus,
        handleClickDeleteVehicleStatus,
        handleClickEditStatus,
        handleChangeAmount,
        handleChangeCheckBox,
        generatePDF,
        handleClickDeleteVehicleAdvance
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}